var _a;
import { proxy, subscribe, useSnapshot } from 'valtio';
export const MUTE_SOUND_NOTIFICATION_KEY = 'pt-mute-sound-notification';
export const muteSoundNotificationStore = proxy({ muted: false });
const storedState = (_a = globalThis.localStorage) === null || _a === void 0 ? void 0 : _a.getItem(MUTE_SOUND_NOTIFICATION_KEY);
if (storedState) {
    muteSoundNotificationStore.muted = JSON.parse(storedState).muted;
}
subscribe(muteSoundNotificationStore, () => {
    var _a;
    (_a = globalThis.localStorage) === null || _a === void 0 ? void 0 : _a.setItem(MUTE_SOUND_NOTIFICATION_KEY, JSON.stringify(muteSoundNotificationStore));
});
const toggleSoundNotificationMuted = () => {
    muteSoundNotificationStore.muted = !muteSoundNotificationStore.muted;
};
export const useMuteSoundNotificationStore = () => {
    var _a;
    const snapshot = useSnapshot(muteSoundNotificationStore);
    return [(_a = snapshot.muted) !== null && _a !== void 0 ? _a : false, toggleSoundNotificationMuted];
};
